// extracted by mini-css-extract-plugin
module.exports = {"ChatSidebarContainer":"Chat_ChatSidebarContainer__u-6Oo","front":"Chat_front__291I_"};